@if (!isConfirming) {
  <div class="font-medium-headline-small">
    Um Ihre Account Erstellung abzuschließen folgen Sie bitte dem Link in der
    Bestätigungsmail.
  </div>
}
@if (isConfirming && !errorMessage) {
  <div class="flex-c gap-4 align-center text-align-center">
    <div class="font-medium-headline-small">Ihre E-Mail wird bestätigt...</div>
    <div class="font-medium-headline-small">Bitte warten Sie einen Moment.</div>
  </div>
}
@if (errorMessage) {
  <div class="flex-c gap-8 align-center">
    <div class="font-medium-headline-small">{{ errorMessage }}</div>
    <button class="inwi-text-button-large-primary" (click)="toLogin()">
      <div class="button-content">
        <span class="button-text"> Zur Anmeldung </span>
      </div>
    </button>
  </div>
}
